


























import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import UserAlertsService from '@/modules/userAlerts/UserAlertsService';
import moment from 'moment';
import notificationService from '@/services/notificationService';

@Component({
  components: {
  },
})
export default class AlertNavItem extends Vue {
    private data: IUserAlert[] = [];
    private initialised: boolean = false;

    private mounted() {
        this.loadData();
    }

    private async loadData() {
        try {
            setTimeout(async () => {
              const result = (await UserAlertsService.get({
                page: 0,
                pageSize: 3,
              })).data;

              if (this.initialised) {
                const idListData = this.data.map((o) => o.id);
                const idListResult = result.map((o) => o.id);

                idListResult.forEach((id: string) => {
                  if (idListData.indexOf(id) === -1) {
                    notificationService.showNotification('Er zijn nieuwe meldingen', 'info');
                  }
                });
              }

              this.data = result;
              this.initialised = true;
              this.loadData();
            }, this.initialised ? 60 * 1000 : 500); // 60 sec
        } catch (err) {
            // Do nothing
        }
    }

    private convertDate(item: IUserAlert) {
        return moment(item.moment).format('DD/MM/YYYY HH:mm');
    }

    get NumberOfUnacknowledged() {
        const no = this.data.filter((o: IUserAlert) => !o.acknowledgedDate).length;
        if (no === 3) {
            return '3+';
        }
        return '' + no;
    }
}
